// @vendors
const get = require('lodash/object/get');
const Immutable = require('immutable');

// @helpers
const apiURLBuilder = require('../core/apiURLBuilder');

// @actions
const actionTypes = require('constants/actionTypes');
const errorActions = require('actions/brokerError');
const signaturePatternActions = require('actions/signaturePattern.js');
const { updateConsents } = require('actions/gdprConsents');

// @utilities
const PersonalDataHelper = require('utilities/personalDataHelper');
const { es: { DATE_FORMAT_WITH_DASHES_DATETIME }} = require('commonsConstants/dateFormatTypes');
const { getLanguage } = require('core/i18n').i18n

// @contact center
const contactCenterActionTypes = require('constants/contactCenter/actionTypes');

const {
    BROKER_STOCKS_CONTRACT_ORDER_TYPE,
    CAMPAIGN_PRICING_CHANNEL,
    CONNECTION_CHANNEL_INTERNET,
    DEFAULT_COUNTRY,
    EURO_TEXT,
    SECOND_STEP
} = require('constants/index');

// @utilities
const { APIPost } = require('utilities/APIRequestHelper');

const contractInformationFetching = () => ({
    type: actionTypes.BROKER_STOCKS_CONTRACT_METHOD_GET_CONTRACT_INFORMATION_FETCHING
});

const contractInformationSucess = information => ({
    type: actionTypes.BROKER_STOCKS_CONTRACT_METHOD_GET_CONTRACT_INFORMATION,
    payload: {
        information
    }
});

const contractInformationFailure = error => ({
    type: actionTypes.BROKER_STOCKS_CONTRACT_METHOD_GET_CONTRACT_INFORMATION_FAILURE,
    payload: {
        error
    }
});

function reset(visibleStep) {
    return {
        type: actionTypes.BROKER_STOCKS_CONTRACT_RESET,
        payload: {
            visibleStepIndex : visibleStep
        }
    };
}

function resetAccount() {
    return {
        type: actionTypes.BROKER_STOCKS_CONTRACT_RESET_ACCOUNT
    }
}

function setAccount(account) {
    return {
        type: actionTypes.BROKER_STOCKS_CONTRACT_SET_ACCOUNT,
        payload: {
            account
        }
    }
}

function setIntervenerName(index, name, originalInterveners) {
    return {
        type: actionTypes.BROKER_STOCKS_CONTRACT_SET_ACCOUNT_INTERVENER_NAME,
        payload: {
            index,
            name,
            originalInterveners
        }
    }
}

function setIntervenerType(index, type) {
    return {
        type: actionTypes.BROKER_STOCKS_CONTRACT_SET_ACCOUNT_INTERVENER_TYPE,
        payload: {
            index,
            type
        }
    }
}

function addIntervener() {
    return {
        type: actionTypes.BROKER_STOCKS_CONTRACT_ADD_INTERVENER
    };
}

function removeIntervener(index, originalInterveners) {
    return {
        type: actionTypes.BROKER_STOCKS_CONTRACT_REMOVE_INTERVENER,
        payload: {
            index,
            originalInterveners
        }
    };
}

function restoreDefaultInterveners(originalInterveners) {
    return {
        type: actionTypes.BROKER_STOCKS_CONTRACT_RESTORE_DEFAULT_INTERVENERS,
        payload: {
            originalInterveners
        }
    }
}

function setVisibleStep(step) {
    return {
        type: actionTypes.BROKER_STOCKS_CONTRACT_SET_VISIBLE_STEP,
        payload: {
            step
        }
    };
}

function setWillLeave() {
    return {
        type: actionTypes.BROKER_STOCKS_CONTRACT_WILL_LEAVE
    };
}

function setWillCancel(value) {
    return {
        type: actionTypes.BROKER_STOCKS_CONTRACT_WILL_CANCEL,
        payload: {
            value
        }
    };
}

function validateUIStep(step) {
    return {
        type: actionTypes.BROKER_STOCKS_CONTRACT_VALIDATE_STEP,
        payload: {
            step
        }
    }
}

function confirmStocksContractRequest() {
    return {
        type: actionTypes.BROKER_STOCKS_CONTRACT_CONFIRM_REQUEST
    }
}

function sendEmailNotificationRequest() {
    return {
        type: actionTypes.BROKER_STOCKS_CONTRACT_EMAIL_NOTIFICATION
    }
}

function sendEmailNotificationSuccess() {
    return {
        type: actionTypes.BROKER_STOCKS_CONTRACT_EMAIL_NOTIFICATION_SUCCESS
    };
}

function sendEmailNotificationError(error) {
    return {
        type: actionTypes.BROKER_STOCKS_CONTRACT_EMAIL_NOTIFICATION_ERROR,
        email:{
            error
        }
    };
}

function confirmStocksContractSuccess(contract) {
    return {
        type: actionTypes.BROKER_STOCKS_CONTRACT_CONFIRM_SUCCESS,
        payload: {
            contract
        }
    }
}

function confirmStocksContractFailure(response) {
    return {
        type: actionTypes.BROKER_STOCKS_CONTRACT_CONFIRM_FAILURE,
        payload: {
            data: response
        }
    }
}

const generateMiFIDDisclaimers = (immBrokerConvenienceMiFIDTest) => {
    const immUSPersonDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']);
    const immDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers']);
    const immAllDisclaimers = Immutable.fromJS([]).merge(immUSPersonDisclaimers).merge(immDisclaimers);

    return immAllDisclaimers.map(immDisclaimer => immDisclaimer.get('description')).join(' | ');
};

const mailPreContractualToClientSuccess = () => ({
    type: contactCenterActionTypes.PRE_CONTRACTUAL_MAIL_SENT_SUCCESS
 });

 const mailPreContractualToClientRequest = () => ({
    type: contactCenterActionTypes.PRE_CONTRACTUAL_MAIL_SENT_REQUEST
 });

 const mailPreContractualToClientFailure = error => ({
    type: contactCenterActionTypes.PRE_CONTRACTUAL_MAIL_SENT_FAILURE,
    payload: {
        error
    }
 });

const finishReadingPrecontractualDocument = () => ({
    type: actionTypes.BROKER_STOCKS_CONTRACT_FINISH_READING_PRECONTRACTUAL_DOCUMENT,
});

const getContractInformationWithPricing = (location, history) => (dispatch, getState) => {
    const isAlreadyFetching = getState().contracts.get('isFetchingStep1');

    if (isAlreadyFetching) return;
    const language = getLanguage() || DEFAULT_COUNTRY;

    const data = {
        query: {
            lang: language.toUpperCase(),
            location: location,
            type: CAMPAIGN_PRICING_CHANNEL
        }
    }

    return new Promise(() => {
        dispatch(contractInformationFetching());
        APIPost(
            dispatch,
            apiURLBuilder.getURL('campaignWithPricing'),
            data
        )
        .then(response => {
            const htmlBody = response.nodes && response.nodes[0] && response.nodes[0].body && response.nodes[0].body[0];
            dispatch(contractInformationSucess(htmlBody && htmlBody.value));
        })
        .catch(response => {
            if (response.error) {
                dispatch(contractInformationFailure(response.error));
                dispatch(errorActions.show("brokerAPIErrors-errorPrimaryMessage", true, history));  //show broker error page
            } else {
                dispatch(errorActions.show("brokerAPIErrors-errorPrimaryMessage", true, history));
                throw response;
            }
        });
    });
};

const sendEmailNotification = (orderResponse, sendOrder = 'Yes', saveDocumentation = 'no') => (dispatch, getState) => {
    let communicationServiceInput, data;
    const immProfile = getState().profile;
    const immContracts = getState().globalVariables.getIn(['variables', 'parameters', 'contratos']);
    const contractServicesIndividuals = immContracts.get('prestacion_servicios_fisicas');
    const immBrokerStocksContractForm = getState().brokerStocksContractForm;
    const step1 = immBrokerStocksContractForm.getIn(['steps', SECOND_STEP, 'account']);
    const emittedDateTime = immBrokerStocksContractForm.get('emissionDate');
    const idContract = get(orderResponse, 'contratoV.numerodecontrato', '');
    const interveners = immBrokerStocksContractForm.getIn(['steps', SECOND_STEP, 'interveners']);

    const holderNames = interveners.map(intervener => {
       return intervener.get('name').trim()
    });

    let orderType, productType;

    if (__CONTACT_CENTER__) {
        orderType = 'contratacion';
        productType ='CCV';
    } else {
        orderType = BROKER_STOCKS_CONTRACT_ORDER_TYPE;
        productType = "";
    }

    communicationServiceInput = {
        "email":PersonalDataHelper.getEmail(immProfile),
        "productKID":"",
        "contract": contractServicesIndividuals,
        "sendOrder": sendOrder,
        "saveDocumentation": __CONTACT_CENTER__ ? saveDocumentation : "",
        "clientAlias": immProfile.get('nombreCliente'),
        "channel": CONNECTION_CHANNEL_INTERNET,
        "orderType": orderType,
        "productType": productType,
        "holders": holderNames.join(','),
        "ccc": step1.get('iban'),
        "currency": EURO_TEXT,
        "mifidWarningText": generateMiFIDDisclaimers(getState().brokerConvenienceMiFIDTest),
        "dateTime" : emittedDateTime.format(DATE_FORMAT_WITH_DASHES_DATETIME),
        "idContract": idContract
    };

    data = {
        query: communicationServiceInput
    };
    dispatch(sendEmailNotificationRequest());
    __CONTACT_CENTER__ && dispatch(mailPreContractualToClientRequest());
    return APIPost(dispatch, apiURLBuilder.getURL('communication'), data).then(
        function () {
            dispatch(sendEmailNotificationSuccess());
            __CONTACT_CENTER__ && dispatch(mailPreContractualToClientSuccess());
        },
        function (response) {
            dispatch(sendEmailNotificationError(response.error))
            __CONTACT_CENTER__ && dispatch(mailPreContractualToClientFailure(response.error));
        }
    );
}

function confirmStocksContract(history) {
    return function(dispatch, getState) {
        const immBrokerStocksContractForm = getState().brokerStocksContractForm;
        const account = immBrokerStocksContractForm.getIn(['steps', SECOND_STEP, 'account']);
        const interveners = immBrokerStocksContractForm.getIn(['steps', SECOND_STEP, 'interveners']);
        const dataToken = immBrokerStocksContractForm.get('dataToken');
        const processedInterveners = interveners.map(intervener => {
            return {
                desIntervencion: intervener.get('type'),
                nombre: intervener.get('name'),
                numPersona: intervener.get('personNum'),
                tipoIntervencion: intervener.get('interventionType'),
                tipoPersona: intervener.get('personType')
            };
        });

        //SICO requirements to check blocked accounts @Ale de la Viña
        const pgAccount = getState().accounts.toJS().byId[account.toJS().accountId];

        const data = {
            query: {
                codMoneda: account.getIn(['balance', 'currency']),
                contratoSel: {
                    numerodecontrato: account.getIn(['contract', 'number']),
                    producto: account.getIn(['contract', 'product'])
                },
                dataToken: dataToken,
                intervinientes: {
                    interviniente: processedInterveners
                },
                numEmp: 111111, //@hardcoded
                subtipo: '001', //@hardcoded
                tipo: '400', //@hardcoded
                //SICO requirements to check blocked accounts @Ale de la Viña
                newContractNumber: pgAccount.newContractNumber,
                newProductNumber: pgAccount.newProduct

            }
        };

        dispatch(confirmStocksContractRequest());
        return APIPost(dispatch, apiURLBuilder.getURL('brokerStocksContractConfirmation') , data)
            .then(response => {
                const sendOrder = __CONTACT_CENTER__ ? "No" : "Yes";
                const saveDocumentation = 'yes';
                dispatch(sendEmailNotification(response, sendOrder, saveDocumentation));
                dispatch(confirmStocksContractSuccess(
                    get(response, 'contratoV', {})
                ));
            }, response => {
                dispatch(confirmStocksContractFailure(response));
                const errorKey = get(response, ["body", "error"], "");
                dispatch(errorActions.show("brokerAPIErrors-" + errorKey, true, history))
            }
        );
    };
}

function setTermsAndConditions(isChecked) {
    return {
        type: actionTypes.BROKER_STOCKS_CONTRACT_SET_TERMS_AND_CONDITIONS,
        payload: {
            isChecked
        }
    }
}

function signaturePatternSuccess(dataToken) {
    return {
        type: actionTypes.BROKER_STOCKS_CONTRACT_SIGNATURE_PATTERN_SUCCESS,
        payload: {
            dataToken
        }
    }
}

const confirmOperation = (history) => (dispatch, getState) => {
    // This is the usual action we call to post data to API. Now it's wrapped as a callback
    const callback = (dispatch, getState, dataToken) => {
        dispatch(updateConsents(dataToken))
            .then(() => {
                dispatch(signaturePatternSuccess(dataToken));
                dispatch(confirmStocksContract(history));
            })
            .catch(() => {
                dispatch(signaturePatternSuccess(dataToken));
                dispatch(confirmStocksContract(history));
            });
    };

    const isAlreadyFetching = getState().brokerStocksContractForm.get('isFetching');

    if (!isAlreadyFetching) {
        // This will call signaturePattern flow, and if everything goes correct, it will call your current callback to save all data
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
   }
}

const validateStep = step => (dispatch) => {
    dispatch(validateUIStep(step));
};

module.exports = {
    addIntervener,
    confirmOperation,
    finishReadingPrecontractualDocument,
    getContractInformationWithPricing,
    removeIntervener,
    reset,
    resetAccount,
    restoreDefaultInterveners,
    setAccount,
    setIntervenerName,
    setIntervenerType,
    setTermsAndConditions,
    setVisibleStep,
    setWillCancel,
    setWillLeave,
    sendEmailNotification,
    validateStep
}
